<script>
import NumberRoller from '@components/number-roller.vue'
import ItemList from '@components/item-list.vue'
import Subslide from '@components/slide-subslide.vue'

export default {
  components: { NumberRoller, ItemList, Subslide },
  props: {
    report: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    subslide: {
      type: Number,
      required: false,
      default: null
    }
  },
  computed: {
    articleItems() {
      return this.report.data.articles.map((article) => ({
        label: article.shortTitle || article.title,
        url: article.url,
      }))
    },
    guideLimit() {
      return Math.floor(Math.min(1400, window.innerWidth) / 250) * 3
    },
  },
}
</script>
<template>
  <div>
    <i18n path="guides.heading" tag="h3"
      ><NumberRoller
        :delay="200"
        :should-start="isActive"
        :to="report.data.pageViews || 0"
    /></i18n>
    <ItemList :items="articleItems" :limit="guideLimit" :expandable="true" />
    <Subslide :index="0" :current-index="subslide">
      <p>
        <em>{{ $t('guides.info_text') }} <a @click="$emit('help')">{{ $t('general.read_more') }} &#xbb;</a></em>
      </p>
    </Subslide>
  </div>
</template>
